import './sideBar.css'
import CountdownTimer from '../countor/countor'
import { getLastIssue } from '../../pages/issues/data'

export default function SideBar() {
    // get last issue from issues list data
    const last_issue = getLastIssue()

    // decrease from the last issue date, to get last time to receive researchs
    let last_time_receiv = new Date(last_issue.date)
    last_time_receiv.setDate(last_time_receiv.getDate()-8)

    // decrease from the last time to receive researches , to show it on Ar
    let last_time_receiv_arabic = new Date(last_time_receiv)
    last_time_receiv_arabic.setDate(last_time_receiv.getDate()-1)
    last_time_receiv_arabic = last_time_receiv_arabic.toLocaleDateString('ar-MA', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

  return (
    <div className="sideBar">
        <div className="DepositNumber">
            <strong>رقم الإيداع</strong>: 2024/03 ص
        </div>
        <div className="issn">
            <strong>ISSN</strong>: 3085-4873
        </div>
        <ol id='release-Date'>
            <li>موعد إصدار العدد القادم </li>
            <li>30 أكتوبر 2026</li>
            <li className="con"><CountdownTimer targetDate='2026-10-30T00:00:00'/></li>
        </ol>
        <div className="mokup">
            <img src='https://rmprs.com/plugins/themes/rmprsTheme/images/mokup.webp' alt="mokup" />
        </div>
        <ol id='last-Date'>
            <li>آخر أجل لإستلام البحوث </li>
            <li style={{color:"#ff4545"}}>25 أكتوبر 2026</li>
            <li className="con"><CountdownTimer targetDate='2026-10-25T00:00:00'/></li>
        </ol>
       {/* {<ol className='inf'>
        <li className="title">
            معلومات المجلة
        </li>
        <li style={{textAlign:'justify'}}>
            <div>
            الإسم : المجلة المغربية لنشر الأبحاث العلمية
            </div>
            <div style={{textAlign:'left'}}>
                Revue Marocaine de Publication des Recherches Scientifiques
            </div>
        </li>
        <li className="title">
            الإختصار : RMPRS
        </li>
        <li>
        تردد النشر: شهرياً
        </li>
        <li>
        فترة التحكيم : من 4 إلى 10 أيام
        </li>
        <li>
            رقم الإيداع : 03/صحافة/2024
        </li>
       </ol>} */}
    </div>
  )
}